function handleDeviceChange() {
  function getDevice() {
    return window.innerWidth < 992 ? 'mobile' : 'desktop';
  }

  let lastDevice = getDevice();

  window.addEventListener('resize', () => {
    const currentDevice = getDevice();

    if (currentDevice !== lastDevice) {
      lastDevice = currentDevice;

      document.dispatchEvent(
        new CustomEvent('deviceChanged', {
          detail: {
            device: currentDevice,
          },
        }),
      );
    }
  });
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  // @ts-ignore
  window.Shopify = {};
}

/**
 * Binds a function to a scope.
 * @param {Function} fn - The function to bind.
 * @param {Object} scope - The scope to bind the function to.
 * @returns {any} - The bound function.
 */
Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

/**
 * Sets the selected option in a selector element by its value or innerHTML.
 * @param {HTMLSelectElement} selector - The selector element.
 * @param {string} value - The value to match.
 * @returns {number | undefined} - The index of the selected option.
 */
Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

/**
 * Format money values based on your shop currency settings
 * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
 * or 3.00 dollars
 * @param  {String} [format] - shop money_format setting
 *
 * @return {String} value - formatted value
 */
Shopify.formatMoney = function (cents, format = window.theme.moneyFormat) {
  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }
  let value = '';
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const formatString = format;

  function formatWithDelimiters(number, precision = 2, thousands = ',', decimal = '.') {
    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    const parts = number.split('.');
    const dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${thousands}`);
    const centsAmount = parts[1] ? decimal + parts[1] : '';

    return dollarsAmount + centsAmount;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

/**
 * Adds an event listener to a target element.
 * @param {EventTarget} target - The target element.
 * @param {string} eventName - The name of the event.
 * @param {EventListenerOrEventListenerObject} callback - The callback function to execute when the event is triggered.
 */
Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : // @ts-ignore - IE8 compatibility
      target.attachEvent('on' + eventName, callback);
};

/**
 * Submits a form by creating and submitting a hidden form element.
 * @param {string} path - The action path for the form.
 * @param {Object} [options] - The options for the form submission.
 * @param {string} [options.method='post'] - The HTTP method for the form submission.
 * @param {Object} [options.parameters={}] - The parameters to include in the form submission.
 */
Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  /**
   * @type {Object<any, string>}
   */
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

/**
 * Creates a new CountryProvinceSelector.
 * @class
 * @param {string} country_domid - The ID of the country selector element.
 * @param {string} province_domid - The ID of the province selector element.
 * @param {Object} options - The options for the CountryProvinceSelector.
 * @param {string} [options.hideElement] - The ID of the element to hide when there are no provinces.
 */
Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  /**
   * @type {HTMLElement | HTMLSelectElement | null}
   */
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);
  if (!this.countryEl) return;

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));
  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    if (!this.countryEl || !(this.countryEl instanceof HTMLSelectElement)) return;
    var value = this.countryEl.getAttribute('data-default');
    if (!value) return;
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    if (!this.provinceEl || !(this.provinceEl instanceof HTMLSelectElement)) return;
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function () {
    if (!this.countryEl || !(this.countryEl instanceof HTMLSelectElement)) return;
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    if (!raw) return;
    var provinces = JSON.parse(raw);

    if (!this.provinceEl || !(this.provinceEl instanceof HTMLSelectElement)) return;
    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      if (this.provinceContainer) {
        this.provinceContainer.style.display = 'none';
      }
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }
      if (this.provinceContainer) {
        this.provinceContainer.style.display = '';
      }
    }
  },

  /**
   * Clears all options from a selector element.
   * @param {HTMLSelectElement} selector - The selector element.
   */
  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  /**
   * Sets the options of a selector element.
   * @param {HTMLSelectElement} selector - The selector element.
   * @param {Array<any>} values - The values to set as options.
   */
  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

/**
 * Gets inner HTML of a section.
 * @param {String} html - HTML markup
 * @param {String} selector - The identifier for the section
 */
function getSectionInnerHTML(html, selector = '.shopify-section') {
  return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
}

/**
 * Gets inner HTML of a section.
 * @param {Array<Object>} sections - Sections to render
 * @param {String} state - Response state
 */
export function renderSections(sections, state) {
  return sections.forEach((section) => {
    const elementToReplace =
      document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
    elementToReplace.innerHTML = getSectionInnerHTML(state.sections[section.section], section.selector);
  });
}

export function setScrollbarWidth() {
  const outer = document.createElement('div');
  outer.style.visibility = 'hidden';
  outer.style.overflow = 'scroll';
  outer.style.msOverflowStyle = 'scrollbar'; // For IE and Edge
  outer.style.width = '100px';
  outer.style.position = 'absolute';

  document.body.appendChild(outer);

  const inner = document.createElement('div');
  inner.style.width = '100%';
  outer.appendChild(inner);

  const scrollbarWidth = outer.offsetWidth - inner.offsetWidth;

  document.body.removeChild(outer);

  document.body.style.setProperty('--scrollbar-width', `${scrollbarWidth}`);
}

document.addEventListener('DOMContentLoaded', () => {
  handleDeviceChange();
  setScrollbarWidth();
});
